import React, { Component } from 'react'

class Person extends Component {
  constructor(props) {
    super(props)
    this.state = {
      personSelected: 0,
      persons: [
        { name: 'joe', age: 26 },
        { name: 'john', age: 32 },
        { name: 'sarah', age: 35 },
      ],
    }
  }

  personHandler = (personNumber) => (ev) => {
    console.log(personNumber)
    // this.state.personSelected = personNumber
    this.setState({ personSelected: personNumber })
    console.log(this.state)
  }

  render() {
    return (
      <>
        <div>{this.state.persons[this.state.personSelected].name}</div>
        <button onClick={this.personHandler(0)}>{'next'}</button>
        <button onClick={this.personHandler(1)}>{'next'}</button>
        <button onClick={this.personHandler(2)}>{'next'}</button>
      </>
    )
  }
}

export default Person
